import { useMemo, useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { hasPermission, hasAnyPermission } from "@/utils/permission-utils";
import { usePermissions } from "react-admin";
import BookingDashboard from "@/containers/bookings/dashboard/BookingDashboard";
import RazaDashboard from "@/containers/raza/dashboard/RazaDashboard";

type DashboardTab = "bookings" | "raza";

export default function BookingsRazaDashboard() {
  const { permissions } = usePermissions();

  const canBookings = hasPermission(permissions, "bookings.view");
  const canRaza = hasAnyPermission(permissions, ["razaRequests.view", "razaEvents.view"]);

  const initialTab = useMemo<DashboardTab>(() => {
    if (canBookings) return "raza";
    return "bookings";
  }, [canBookings]);

  const [tab, setTab] = useState<DashboardTab>(initialTab);

  if (canBookings && !canRaza) {
    return <BookingDashboard />;
  }
  if (!canBookings && canRaza) {
    return <RazaDashboard />;
  }

  return (
    <Box>
      <Tabs
        value={tab}
        onChange={(_evt, next: DashboardTab) => setTab(next)}
        sx={{ mb: 1 }}
        aria-label="Raza and bookings dashboard tabs"
      >
        <Tab value="raza" label="Raza & Events Overview" />
        <Tab value="bookings" label="Bookings Overview" />
      </Tabs>
      {tab === "bookings" ? <BookingDashboard /> : <RazaDashboard />}
    </Box>
  );
}
